import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type SceneState = {
  hover?: string;
  selection?: string;
  sceneLoading?: boolean;
  sceneLoadCount: number;
  isCapturing?: boolean;
};

const initialState: SceneState = {
  hover: undefined,
  selection: undefined,
  sceneLoading: false,
  sceneLoadCount: 0,
  isCapturing: false,
};

const editorSceneSlice = createSlice({
  name: 'editorScene',
  initialState,
  reducers: {
    clear: state => {
      state.hover = undefined;
      state.selection = undefined;
      state.isCapturing = false;
    },
    setHover: (state, action: PayloadAction<string | undefined>) => {
      state.hover = action.payload;
    },
    setSelection: (state, action: PayloadAction<string | undefined>) => {
      state.selection = action.payload;
    },
    setSceneLoading: (state, action: PayloadAction<boolean>) => {
      state.sceneLoading = action.payload;
    },
    startSceneLoad: state => {
      state.sceneLoadCount += 1;
      state.sceneLoading = true;
    },
    finishSceneLoad: state => {
      state.sceneLoadCount = Math.max(0, state.sceneLoadCount - 1);
      if (state.sceneLoadCount === 0) {
        state.sceneLoading = false;
      }
    },
    setIsCapturing: (state, action: PayloadAction<boolean>) => {
      state.isCapturing = action.payload;
    },
  },
});

export const {
  clear,
  setHover,
  setSelection,
  setSceneLoading,
  startSceneLoad,
  finishSceneLoad,
  setIsCapturing,
} = editorSceneSlice.actions;

export const editorSceneReducer = editorSceneSlice.reducer;
